import { SearchTerm } from './SearchTerm';

const TimeTriggeredActionSearch: SearchTerm[] = [
    {
        heading: 'Name',
        accessor: 'name',
        searchOnName: 'taName',
        translationKey: "name"
    },
    {
        heading: "Time Pattern",
        accessor: "timePattern",
        searchOnName: "timePattern.tpName",
        translationKey: "timePattern"
    },
    {
        heading: 'Device',
        accessor: 'device',
        searchOnName: 'devAction.deviceImprox.devName',
        translationKey: "device"
    },
    {
        heading: "Action Type",
        accessor: "actionType",
        searchOnName: 'devAction.deviceAction.actionType.trnName',
        translationKey: "actionType"
    },
    {
        heading: 'Action Name',
        accessor: 'actionName',
        searchOnName: 'devAction.setting.trnName',
        translationKey: "actionName"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "devAction.deviceImprox.site.siteName",
        translationKey: "site"
    }
];

export default TimeTriggeredActionSearch;
